import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/Layout';
import ScrollToTopButton from './components/ScrollToTopButton'; // ✅ Import button
import Aos from 'aos';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    Aos.init({ once: true });
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
        </Route>
      </Routes>

      <ScrollToTopButton /> {/* ✅ Add button below routes */}
    </>
  );
}

export default App;
